import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Welcome Section Component
 * Features:
 * - Asymmetrical layout (image + text)
 * - Responsive grid layout
 * - Modern card design
 */
const Welcome = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <img
              src={`${process.env.PUBLIC_URL}/inc/images/Royal_rooms_Napels_1.jpg`}
              alt="Naples"
              className="w-full h-[400px] sm:h-[500px] object-cover rounded-2xl shadow-2xl"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-navy">
              {t('home.welcomeTitle')}
            </h2>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
              {t('home.welcomeText')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;

